export default {
  startupProfileFieldLabel,
}

const mapping = {
  name: 'Name',
  logo_url: 'Logo',
  bg_img_url: 'Background image',
  sectors: 'Sectors',
  caption: 'Short description',
  country: 'Country',
  city: 'City',
  business_type: 'Business type',
  employees_count: 'Team members',
  product_type: 'Product type',
  stage: 'Company stage',
  annual_revenue: 'Annual revenue',
  monthly_recurring_revenue: 'MRR',
  intellectual_property: 'IP',
}

export function startupProfileFieldLabel(field) {
  return mapping[field]
}
